import { register } from '../../../JavaScript/Utils'
import { CookieFirstConsentDetail } from "../CookieConsentContentLoader/CookieConsentContentLoader";

export const InlineFrame = (el: HTMLIFrameElement) => {
  const trackingCategory = el.dataset.trackingCategory || ''

  // stop here if no tracking category is set in the backend
  if (!trackingCategory) {
    return
  }

  // reload the iFrame with track=true if the user accepted the tracking category defined in the backend by the editor
  const consentHandler = (givenConsents: CookieFirstConsentDetail) => {
    if (!Object.prototype.hasOwnProperty.call(givenConsents, trackingCategory)) {
      return;
    }
    if (givenConsents[trackingCategory as keyof CookieFirstConsentDetail]) {
      el.src = `${el.src}${el.src.includes('?') ? '&' : '?'}track=true`
    }
  }

  // handle consent if object already exists or gets updated by the user
  const localStorageConsent = localStorage.getItem('cookiefirst-consent')

  if (localStorageConsent) {
    consentHandler(JSON.parse(localStorageConsent))
  } else if (window.CookieFirst) {
    consentHandler(window.CookieFirst.consent)
  }
  window.addEventListener('cf_consent', (e: CustomEvent) => consentHandler(e.detail))
}

register('InlineFrame', InlineFrame)
